<!-- eslint-disable vuejs-accessibility/tabindex-no-positive -->
<template>
  <nav
    class="
      absolute left-1/2 top-navbar-height -translate-x-1/2 -translate-y-full
      transition-transform duration-300
      focus-within:z-menu focus-within:-translate-y-0
    "
  >
    <ul
      class="
        flex flex-col items-center gap-4 rounded-bl-lg border-red-500 bg-white
        p-8 pt-12
        focus-within:border
      "
    >
      <li>
        <AppButton
          tabindex="1"
          type="button"
          class="text-red-500"
          @click="jumpToId('jump-navigation')"
          @focus="navigation.setOpenState(false)"
        >
          {{ $t('navigate.to_nav') }}
        </AppButton>
      </li>
      <li>
        <AppButton
          tabindex="1"
          class="text-red-500"
          @click="jumpToId('jump-content')"
          @focus="navigation.setOpenState(false)"
        >
          {{ $t('navigate.to_content') }}
        </AppButton>
      </li>
    </ul>
  </nav>
</template>

<script setup lang="ts">
const navigation = useNavigationStore()

function jumpToId(id: string) {
  const el = document.getElementById(id)
  if (id === 'jump-navigation' && el?.getElementsByTagName('a')?.[0]) {
    document.getElementById('nav-collapse')?.getElementsByTagName('a')[0]?.focus() // jump to first link in navigation
    navigation.setOpenState(true)
  } else {
    el?.focus() // focus element, it needs tabindex="-1" to be focusable
  }
  el?.scrollIntoView({ behavior: 'smooth' })
}
</script>
